import { makeStyles } from "@material-ui/core/styles";
import { MONTSERRAT_FONTS } from "../../constants/styleConstants";

const UserStylesPage = makeStyles((theme) => ({
  usersSectionTitle: {
    color: theme.palette.primary.main,
    marginTop: 30,
  },
  mainContainer: {
    marginLeft: 80,
  },
  saveUserButton: {
    marginTop: 50,
    borderRadius: 10,
    height: 40,
    textTransform: "none",
  },
  addUserBtn: {
    fontFamily: MONTSERRAT_FONTS.MONTSERRAT_MEDIUM,
    fontSize: 14,
  },
}));

export default UserStylesPage;
